import { CartItem } from '@/entities/cart';

export function isCartItemAvailable(item: CartItem): boolean {
  return item.selectedPrice.is_available;
}

export function getAvailableCartItems(items: CartItem[]): CartItem[] {
  return items.filter(isCartItemAvailable);
}
